// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSectionGrid-Heading_cls1__BRCcS","cls2":"VeloSectionGrid-Heading_cls2__uZg9L VeloSectionGrid-Heading_cls1__BRCcS"};